// fareastsummit-theme/assets/fes-alpha-nav.js

(function () {
  function sortAndGroupGrid(gridEl, dataAttr) {
    var items = Array.from(gridEl.querySelectorAll('li[' + dataAttr + ']'));

    items.sort(function (a, b) {
      return (a.getAttribute(dataAttr) || '').localeCompare(
        b.getAttribute(dataAttr) || '',
        undefined,
        { sensitivity: 'base' }
      );
    });

    var presentLetters = new Set();
    var currentLetter = '';
    var fragment = document.createDocumentFragment();

    items.forEach(function (item) {
      var name = item.getAttribute(dataAttr) || '';
      var first = name.charAt(0).toUpperCase();
      var letter = /[A-Z]/.test(first) ? first : '#';

      if (letter !== currentLetter) {
        currentLetter = letter;
        presentLetters.add(letter);
        var id = letter === '#' ? 'letter-hash' : 'letter-' + letter;
        var li = document.createElement('li');
        li.className = 'pinyin-grid__letter-li';
        li.setAttribute('aria-hidden', 'true');
        var span = document.createElement('span');
        span.className = 'pinyin-grid__letter-row';
        span.id = id;
        span.textContent = letter;
        li.appendChild(span);
        fragment.appendChild(li);
      }

      fragment.appendChild(item);
    });

    gridEl.replaceChildren(fragment);
    return presentLetters;
  }

  function buildAlphaNav(navEl, presentLetters) {
    var all = ['#', 'A','B','C','D','E','F','G','H','I','J','K','L','M',
               'N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
    var fragment = document.createDocumentFragment();

    all.forEach(function (letter) {
      var id = letter === '#' ? 'letter-hash' : 'letter-' + letter;
      var active = presentLetters.has(letter);
      var el;
      if (active) {
        el = document.createElement('a');
        el.href = '#' + id;
        el.className = 'fes-alpha-nav__item fes-alpha-nav__item--active';
      } else {
        el = document.createElement('span');
        el.className = 'fes-alpha-nav__item';
      }
      el.textContent = letter;
      fragment.appendChild(el);
    });

    navEl.innerHTML = '';
    navEl.appendChild(fragment);
  }

  window.FesAlphaNav = { sortAndGroupGrid: sortAndGroupGrid, buildAlphaNav: buildAlphaNav };
})();
